import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

export default function EmptyState({
  title,
  description,
  icon,
  actions,
  className,
}: {
  title: string;
  description: string;
  icon?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-dashed border-border/80 bg-muted/20 p-8 text-center",
        className,
      )}
    >
      {icon ? <div className="mb-4 inline-flex text-muted-foreground">{icon}</div> : null}
      <div className="space-y-2">
        <p className="text-base font-medium">{title}</p>
        <p className="mx-auto max-w-xl text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      {actions ? <div className="mt-5 flex justify-center gap-2">{actions}</div> : null}
    </div>
  );
}
